/**
 * Central API base URL for the marketing site.
 *
 * Production builds always use REACT_APP_API_BASE_URL.
 *
 * Local development: set REACT_APP_USE_LOCAL_API=true in .env to use
 * REACT_APP_API_BASE_URL_LOCAL instead (e.g. http://192.168.1.132:8000/api).
 */
const productionUrl = process.env.REACT_APP_API_BASE_URL || "";
const localUrl = process.env.REACT_APP_API_BASE_URL_LOCAL || "";
const useLocalApi =
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_USE_LOCAL_API === "true";

export const API_BASE_URL = useLocalApi ? localUrl || productionUrl : productionUrl;

export const isUsingLocalApi = useLocalApi && Boolean(localUrl);
